import { fg } from '@townsquare/stat-sig/gate';

import { LoadingSkeletonCompiled, LoadingSkeletonContainerCompiled } from './styles.compiled';
import { LoadingSkeletonContainerStyled, LoadingSkeletonStyled } from './styles.styled';

export const LoadingSkeletonContainer = fg('townsquare_compiled_css_migration')
	? LoadingSkeletonContainerCompiled
	: LoadingSkeletonContainerStyled;

export const LoadingSkeleton = fg('townsquare_compiled_css_migration')
	? LoadingSkeletonCompiled
	: LoadingSkeletonStyled;
